import React from 'react';
import HeaderDashboard from '../Components/HeaderDashboard'

const Approval = () => (
    <>
        <HeaderDashboard></HeaderDashboard>
        <div className="toolbar py-2" id="kt_toolbar">
            <div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
                <div className="flex-grow-1 flex-shrink-0 me-5">
                    <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                        <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">Dashboard</h1>
                        <span className="h-20px border-gray-200 border-start mx-3"></span>
                        <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                            <li className="breadcrumb-item">
                                <a href="/dashboard/approval" className="text-muted text-hover-primary">Approval</a>
                            </li>

                        </ul>
                    </div>
                </div>

            </div>
        </div>

        <section className='wraper'>
            <div className='box_shadow mt-14'>
                 <div class="row">
                        <div class="col-md-3 mb-3">
                            <div class="form-group">
                                <label class="">From Date</label>
                                <input class="form-control form-control-solid" name="fromDate" type="date" defaultValue="" placeholder=""
                                   
                                />
                            </div>
                        </div>
                        <div class="col-md-3 mb-3">
                            <div class="form-group">
                                <label class="">To Date</label>
                                <input class="form-control form-control-solid" name="toDate" type="date" defaultValue="" placeholder=""
                                 
                                />
                            </div>
                        </div>

                       
                        <div class="col-md-3 mb-3">
                            <div class="form-group">
                                <label class="">Status</label>
                                <select class="form-select form-select-solid" name="bookingStatus" >
                                    <option defaultValue="">--Select Type--</option>
                                    <option value="ALL">ALL</option>
                                    <option value="OnRequest">OnRequest</option>
                                    <option value="Confirmed">Confirmed</option>
                                    <option value="Blocked">Blocked</option>
                                    <option value="Released">Released</option>
                                    <option value="Hold">On Hold</option>
                                    <option value="Failure">Failed</option>
                                    <option value="Cancelled">Cancelled</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3 mb-3">
                            <button type="button" class="btn btn-primary mt-7">
                               Search
                            </button>
                        </div>
                    </div>
            </div>
      
            <div className='box_shadow mt-3'>
                <div class="row">
                    <div class="col-md-12">
                        <h1 className='PendingApproval'>Queue</h1>
                    </div>
                    <div class="col-md-12 mb-3">
                        <div class="table-responsive">
                           <table class="table table-striped">
                                <thead>
                                    <tr class="fw-bold bg-light">
                                        <th class="ps-4">Sr No</th>
                                        <th>Traveler Name</th>                                       
                                        <th>PNR</th>                                       
                                        <th>Origin</th>                                       
                                        <th>Destination</th>                                       
                                        <th>Journey Date</th>                                        
                                        <th>Amount</th>
                                        <th className='text-center'>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="ps-4">1</td>
                                        <td>Ram Singh</td>
                                        <td>96885865</td>
                                        <td>DEL</td>
                                        <td>BOM</td>
                                        <td>12/25/2025</td>
                                        <td><i className='fa fa-inr'></i> 5252</td>
                                        <td className='view_img_icon'>
                                        <a href='/dashboard/approval/Approval-detail' className='view_detals' title="details"> <img src='/assets/images/details.png' alt='approved'></img> </a>
                                        <a href='/' className='view_detals' title="pending"> <img src='/assets/images/pending.png' alt='approved'></img> </a>
                                         
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="ps-4">1</td>
                                        <td>Ram Singh</td>
                                        <td>96885865</td>
                                        <td>DEL</td>
                                        <td>BOM</td>
                                        <td>12/25/2025</td>
                                        <td><i className='fa fa-inr'></i> 5252</td>
                                        <td className='view_img_icon'>
                                        <a href='/dashboard/approval/Approval-detail' className='view_detals' title="details"> <img src='/assets/images/details.png' alt='approved'></img> </a>
                                        <a href='/' className='view_detals' title="approved"> <img src='/assets/images/approved.png' alt='approved'></img> </a>                                           
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="ps-4">1</td>
                                        <td>Ram Singh</td>
                                        <td>96885865</td>
                                        <td>DEL</td>
                                        <td>BOM</td>
                                        <td>12/25/2025</td>
                                        <td><i className='fa fa-inr'></i> 5252</td>
                                        <td className='view_img_icon'>
                                        <a href='/dashboard/approval/Approval-detail' className='view_detals' title="details"> <img src='/assets/images/details.png' alt='approved'></img> </a>
                                        <a href='/' className='view_detals' title="cancelled"> <img src='/assets/images/cancelled.png' alt='approved'></img> </a>
                                           
                                        </td>
                                    </tr>
                                   
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    </>
);

export default Approval;